import React, { useState } from 'react';
import classNames from 'classnames';

import { IconDarkColor } from '@trello/nachos/icon';
import { EditIcon } from '@trello/nachos/icons/edit';
import { token } from '@trello/theme';

import styles from './EditCardButton.less';

interface EditCardButtonProps {
  onClick: () => void;
  shouldShow: boolean;
}

export const EditCardButton = ({
  onClick,
  shouldShow,
}: EditCardButtonProps) => (
  <button
    className={classNames(styles.editCardButton, shouldShow && styles.show)}
    onClick={onClick}
  >
    <EditIcon
      color={token('color.text.accent.gray.bolder', IconDarkColor)}
      size="small"
    />
  </button>
);

export const useEditCardButton = () => {
  const [shouldShowEditCardButton, setShouldShowEditCardButton] = useState(
    false,
  );

  const showEditCardButton = () => setShouldShowEditCardButton(true);
  const hideEditCardButton = () => setShouldShowEditCardButton(false);

  return {
    showEditCardButton,
    hideEditCardButton,
    shouldShowEditCardButton,
  };
};
